<template>
    <div class="group relative inline-block max">
        <span class="">{{ renderValue(value) }}</span>
        <div :class="tooltipClass">{{ value }}</div>
    </div>
</template>

<script>

export default {
    methods: {
        renderValue(value) {
            return value.length > this.maxLength ? value.substring(0, this.maxLength-2) + '...' : value;
        }
    },
    props: {
        value: String,
        tooltipClass: String,
        maxLength: {
            type: Number,
            default: 50
        }
    }
};
</script>
